module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/en_5-1b2e561234ac3393e44813a058ad10a0.jpg";